import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { UserInterests } from '@zero/depot/domain';
import { environment } from 'environments/environment';
import { Observable, of } from 'rxjs';
import { LombardConfirmationData } from '../entities/lombard-confirmation.entity';
import { Lombard } from '../entities/lombard.entity';

@Injectable({ providedIn: 'root' })
export class LombardInfrastructure {
  readonly #http = inject(HttpClient);
  readonly #api = `${environment.apihost}/api/lombard`;
  readonly #confirmationApi = `${this.#api}/confirmationdata`;
  readonly #dismissApi = `${this.#api}/lombarddismissoffer`;
  readonly #interestsApi = `${environment.apihost}${environment.usersettings}/interests`;

  public getFAQs = () => of(['use-case', 'payback', 'loan-value', 'scope'] as string[]);
  public getLombard = (): Observable<Lombard> => this.#http.get<Lombard>(this.#api);
  public apply = (requestedCreditAmount: number): Observable<Lombard> => this.#http.post<Lombard>(this.#api, { requestedCreditAmount });
  public getConfirmationData = (): Observable<LombardConfirmationData> => this.#http.get<LombardConfirmationData>(this.#confirmationApi);
  public dismissTeaser = (): Observable<UserInterests> => this.#http.post<UserInterests>(this.#interestsApi, { lombard_interested: false });
  public dismissOffer = (): Observable<Lombard> => this.#http.post<Lombard>(`${this.#dismissApi}`, {});
}
